import { Alerts, Charts, Communication, Development, Editor, Finance, General, Time, Users } from '@poseidon/components/StrokeIcons';

import type { SuperadminNavCardData } from '~/components/SuperadminNavCard';

// Superadmin pages, grouped. "Daily" holds what operators open every day; the rest is searchable below it.
export const ADMIN_SECTIONS: { title: string; cards: SuperadminNavCardData[] }[] = [
  {
    title: 'Daily',
    cards: [
      { href: '/superadmin/doneforyou', title: 'Done for you', description: 'Client management', Icon: Editor.Wand, iconClassName: 'text-pink-600 dark:text-pink-400' },
      { href: '/superadmin/users', title: 'Users', description: 'Manage user accounts', Icon: Users.User02, iconClassName: 'text-blue-600 dark:text-blue-400' },
      { href: '/superadmin/teams', title: 'Teams', description: 'Manage team accounts', Icon: Users.Users01, iconClassName: 'text-green-600 dark:text-green-400' },
      { href: '/superadmin/team-analytics', title: 'Team Analytics', description: 'One team: activity, rates, every action', Icon: Charts.BarChartSquare02, iconClassName: 'text-emerald-600 dark:text-emerald-400' },
    ],
  },
  {
    title: 'Accounts & Directory',
    cards: [
      { href: '/superadmin/oracle', title: 'Oracle', description: 'Search people & orgs', Icon: General.SearchRefraction, iconClassName: 'text-sky-600 dark:text-sky-400' },
    ],
  },
  {
    title: 'AI',
    cards: [
      { href: '/superadmin/ai', title: 'AI Templates', description: 'Manage AI prompts', Icon: Editor.Sparkle, iconClassName: 'text-indigo-600 dark:text-indigo-400' },
      { href: '/superadmin/aiModels', title: 'AI Models', description: 'Configure AI models', Icon: General.Zap, iconClassName: 'text-yellow-600 dark:text-yellow-400' },
      { href: '/superadmin/aiUsage', title: 'AI Usage', description: 'Cost & usage tracking', Icon: General.Zap, iconClassName: 'text-green-600 dark:text-green-400' },
      { href: '/superadmin/reports/ai-quality', title: 'AI Quality Report', description: 'Message modification tracking', Icon: Editor.Sparkle, iconClassName: 'text-violet-600 dark:text-violet-400' },
    ],
  },
  {
    title: 'Cadences & Execution',
    cards: [
      { href: '/superadmin/flow', title: 'Flow', description: 'Contact journey engine', Icon: Development.GitMerge, iconClassName: 'text-indigo-600 dark:text-indigo-400' },
      { href: '/superadmin/unipile-execution', title: 'Unipile Execution', description: 'Live cadence sending', Icon: General.Zap, iconClassName: 'text-blue-600 dark:text-blue-400' },
      { href: '/superadmin/interrupted', title: 'Interrupted Cadences', description: 'View all interrupted cadences', Icon: Alerts.AlertTriangle, iconClassName: 'text-amber-600 dark:text-amber-400' },
      { href: '/superadmin/unadvanced-candidates', title: 'Unadvanced Candidates', description: 'Candidates not yet in a campaign', Icon: Users.UserPlus01, iconClassName: 'text-fuchsia-600 dark:text-fuchsia-400' },
    ],
  },
  {
    title: 'Email & Deliverability',
    cards: [
      { href: '/superadmin/seed-inboxes', title: 'Seed Inboxes', description: 'Email placement testing', Icon: Communication.Mail01, iconClassName: 'text-cyan-600 dark:text-cyan-400' },
      { href: '/superadmin/email-health', title: 'Email Health', description: 'Fleet, anomalies & events', Icon: Communication.Mail02, iconClassName: 'text-rose-600 dark:text-rose-400' },
      { href: '/superadmin/notifications', title: 'Notifications', description: 'Outbox + delivery status', Icon: Alerts.Bell01, iconClassName: 'text-amber-600 dark:text-amber-400' },
      { href: '/superadmin/overdue-email-cleanup', title: 'Overdue Emails', description: 'Clean up overdue first emails', Icon: Time.Clock, iconClassName: 'text-orange-600 dark:text-orange-400' },
    ],
  },
  {
    title: 'Reports & Data',
    cards: [
      { href: '/superadmin/graphs', title: 'Graphs', description: 'Data visualization', Icon: Charts.BarChartSquare02, iconClassName: 'text-orange-600 dark:text-orange-400' },
      { href: '/superadmin/reports/mid-funnel', title: 'Mid-Funnel Report', description: 'AI outreach response rates', Icon: Charts.BarChartSquare02, iconClassName: 'text-cyan-600 dark:text-cyan-400' },
      { href: '/superadmin/org-enrichment', title: 'Org Enrichment', description: 'Enrich org data', Icon: General.Building07, iconClassName: 'text-teal-600 dark:text-teal-400' },
    ],
  },
  {
    title: 'Logs & Diagnostics',
    cards: [
      { href: '/superadmin/call-step-reconcile', title: 'Call Step Reconcile', description: 'Fix calls vs finished call steps', Icon: Communication.Phone, iconClassName: 'text-green-600 dark:text-green-400' },
      { href: '/superadmin/interaction-log', title: 'Interaction Log', description: 'Debug meeting detection', Icon: Communication.MessageSquare01, iconClassName: 'text-blue-600 dark:text-blue-400' },
      { href: '/superadmin/audit-log', title: 'Audit Log', description: 'System setting changes', Icon: General.Settings01, iconClassName: 'text-blue-600 dark:text-blue-400' },
      { href: '/superadmin/api-limits', title: 'API Limits', description: 'Vendor credits, balances & quotas', Icon: Finance.Coins01, iconClassName: 'text-emerald-600 dark:text-emerald-400' },
    ],
  },
];
